"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var APIKeyManager_less_1 = __importDefault(require("./APIKeyManager.less"));
var AddKeyItem_1 = __importDefault(require("./AddKeyItem"));
var tmdbApi_1 = require("stremio/common/tmdbApi");
var APIKeyManager = function (_a) {
    var onKeySavedChange = _a.onKeySavedChange;
    var _b = (0, react_1.useState)(''), draft = _b[0], setDraft = _b[1];
    (0, react_1.useEffect)(function () {
        var current = (0, tmdbApi_1.getTMDBApiKey)() || '';
        setDraft(current);
    }, []);
    (0, react_1.useEffect)(function () {
        var onChange = function () {
            var current = (0, tmdbApi_1.getTMDBApiKey)() || '';
            setDraft(current);
        };
        window.addEventListener('storage', onChange);
        return function () { return window.removeEventListener('storage', onChange); };
    }, []);
    var onSubmit = (0, react_1.useCallback)(function () {
        var next = draft.trim();
        (0, tmdbApi_1.setTMDBApiKey)(next);
        onKeySavedChange === null || onKeySavedChange === void 0 ? void 0 : onKeySavedChange(next);
    }, [draft, onKeySavedChange]);
    var onClear = (0, react_1.useCallback)(function () {
        (0, tmdbApi_1.setTMDBApiKey)('');
        setDraft('');
        onKeySavedChange === null || onKeySavedChange === void 0 ? void 0 : onKeySavedChange('');
    }, [onKeySavedChange]);
    return (react_1.default.createElement("div", { className: APIKeyManager_less_1.default['wrapper'] },
        react_1.default.createElement("div", { className: APIKeyManager_less_1.default['content'] },
            react_1.default.createElement(AddKeyItem_1.default, { value: draft, onChange: setDraft, onSubmit: onSubmit, onClear: onClear }))));
};
exports.default = APIKeyManager;
